<p-panel header="Temporal Subsetting" [toggleable]="true" class="validation-small-row">
    <ng-template pTemplate="icons">
        <label  class="p-panel-header-icon"
                pTooltip="Select validation period and temporal matching window."
                tooltipPosition="bottom">
          <span class="pi pi-question-circle"></span>
        </label>
    </ng-template>
    
    <!--      Validation period-->   
    <div class="w-12 text-center py-0 my-0">
      <span><b>Validation Period</b></span>
      <span class="pi pi-question-circle pl-2"
          pTooltip="Restricts the input and reference data to the time period given. Days 'from' and 'to' are fully included in the interval. The dates are adapted to match the temporal coverage of the selected data sets."
          tooltipPosition="bottom">
      </span>
    </div>
  
    <div class="grid">

    <!-- left  -->
    <div class="col-12 md:col-6 mt-5" id="fromField">
      <div class="flex align-items-center justify-content-center gap-2">
        <strong>From:</strong>
        <p-floatLabel>
          <p-datepicker inputId="fromDateInputId" id="fromDateInput" dateFormat="yy-mm-dd"
                          [maxDate]="validationPeriodModel.intervalTo$|async"
                          [ngModel]="(validationPeriodModel.intervalFrom$|async)"
                          (ngModelChange)="validationPeriodModel.intervalFrom$.next($event)"></p-datepicker>
          <label for="fromDateInputId">Choose a date</label>
        </p-floatLabel>
       </div>     
    </div>

    <!-- right  -->
    <div class="col-12 md:col-6 mt-5" id="toField">
      <div class="flex align-items-center justify-content-center gap-2">
        <strong>To:</strong>
        <p-floatLabel>
          <p-datepicker inputId="toDateInputId" id="toDateInput" dateFormat="yy-mm-dd"
                          [minDate]="validationPeriodModel.intervalFrom$|async"
                          [ngModel]="(validationPeriodModel.intervalTo$|async)"
                          (ngModelChange)="validationPeriodModel.intervalTo$.next($event)"></p-datepicker>
          <label for="toDateInputId">Choose a date</label>
        </p-floatLabel>
      </div>     
    </div>
  </div>

</p-panel>